import React from "react";

const GetTitle = (PageTitle) => {
	PageTitle = PageTitle && PageTitle.snippet;
    PageTitle = PageTitle.replace('| RR Donnelley', '');
    PageTitle = PageTitle.replace('| RRD Marketing Solutions', '');
    PageTitle = PageTitle.replace('| RRD', '');
    return PageTitle;
}
const GetFileName = s => s.includes('/') && s.substr(s.lastIndexOf('/') + 1);


export default ({ result,onClickLink }) => (
  <div className="sui-result">
    <div className="sui-result__header">
	  <a onClick={onClickLink} className="sui-result__title sui-result__title-divnk"
                dangerouslySetInnerHTML={{ __html: result.title ? GetTitle(result.title) : GetFileName(result.url_path.raw) }}
	  rel= "noopener noreferrer"
	  href={result.url.raw}
	  />
    </div>
        <div className="sui-result__body">
	 <div className="sui-result__details">
	 <div>
           <span
            className="sui-result__value"
            dangerouslySetInnerHTML={{
              __html: result.url.raw
            }}
          />
        </div>
        <div>
           {/*<span*/}
           {/* className="sui-result__value"*/}
           {/* dangerouslySetInnerHTML={{*/}
           {/*     __html: result.meta_description.raw*/}
           {/* }}*/}
           {/*  />*/}

            <span
                className="sui-result__value"
                dangerouslySetInnerHTML={{
                    __html: result.meta_description && result.meta_description.raw 
                }}
            />
        </div>
                </div>
	 </div>
 
  </div>
);
